import React from 'react';
import './custom.scss';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import BrightspaceServices from './BrightspaceServices';
import H5PServices from './H5PServices';
import { CookiesProvider } from "react-cookie";
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <CookiesProvider>
    <BrowserRouter>
      <Switch>
        <Route exact path="/h5p-status" component={H5PServices} />
        <Route path="/" component={BrightspaceServices} />
      </Switch>
    </BrowserRouter>
  </CookiesProvider>,
  document.getElementById('root')
);

reportWebVitals();